import { TableRow, TableCell } from '../ui/Table';

// ----------------------------------------------------------------------

interface TableEmptyRowsProps {
  height?: number;
  emptyRows: number;
  colSpan?: number;
}

export default function TableEmptyRows({ height, emptyRows, colSpan = 9 }: TableEmptyRowsProps) {
  if (!emptyRows) {
    return null;
  }

  return (
    <TableRow
      className="table-row-empty"
      style={{
        ...(height && {
          height: height * emptyRows
        })
      }}
    >
      <TableCell colSpan={colSpan} />
    </TableRow>
  );
}
